import { useEffect, useState } from "react";

const MOBILE_BREAKPOINT = 640; // Tailwind `sm:` breakpoint

export function useIsMobile(): boolean {
	const [isMobile, setIsMobile] = useState(
		typeof window !== "undefined"
			? window.innerWidth < MOBILE_BREAKPOINT
			: false,
	);

	useEffect(() => {
		const mql = window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT - 1}px)`);
		const onChange = (e: MediaQueryListEvent) => setIsMobile(e.matches);
		mql.addEventListener("change", onChange);
		setIsMobile(mql.matches);
		return () => mql.removeEventListener("change", onChange);
	}, []);

	return isMobile;
}
